import { useContext } from "react";
import { ErrorBoundaryContext } from "../contexts/ErrorBoundaryContext";

export const useErrorBoundary = () => {
  return useContext(ErrorBoundaryContext);
};

export const ErrorBoundaryProvider = ({ hasError, children }) => {
  return (
    <ErrorBoundaryContext.Provider value={{ hasError: hasError }}>
      {children}
    </ErrorBoundaryContext.Provider>
  );
};
